exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sms-settings-key[data-v-4c145909] {\n  margin-top: 20px;\n  margin-right: 10px;\n  width: 20%;\n  display: inline-block;\n}\n.sms-settings-key input[data-v-4c145909] {\n    width: 100%;\n}\n.save-sms-key-btn[data-v-4c145909] {\n  display: inline-block;\n  margin-right: 5px;\n  width: 8% !important;\n}\n", ""]);

// exports
